'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { useIsLoggedIn } from '@air/utils-auth';

import { Routes } from '~/constants/Routes';
import { useWithShopifyParams } from '~/hooks/useWithShopifyParams';
import { saveShopifyParams } from '~/utils/sessionStorage';

export const useUnauthenticatedRedirect = ({ loginPath = Routes.Login }: { loginPath?: string } = {}) => {
  const { isLoggedIn, isLoggedInFetched } = useIsLoggedIn();
  const router = useRouter();
  const { withShopifyParamsRef } = useWithShopifyParams();

  useEffect(() => {
    if (isLoggedInFetched && !isLoggedIn) {
      saveShopifyParams(window.location.search);
      router.push(withShopifyParamsRef.current(loginPath));
    }
  }, [isLoggedIn, isLoggedInFetched, loginPath, router, withShopifyParamsRef]);
};
